<template>
  <div>
    <!--notif jadwal-->
    <v-card tile flat class="bg-card">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="12" class="pa-5 black--text">
            <base-breadcrumbs class="pa-0" :items="breadcrumbs" />
            <div class="headline">
              {{ jenis === 'luring' ? 'Sertifikat Diklat Luring Tersistem' : 'Sertifikat Bimtek Calon Master Pelatih' }}
            </div>
            Silakan klik tombol HASIL KELAS untuk mengetahui hasil nilai dan mengunduh sertifikat peserta
            {{ jenis === 'luring' ? 'Diklat Luring Tersistem' : 'Bimtek Calon Master Pelatih' }}
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card>
      <v-card-title class="pa-0">
        <base-table-header @search="onSearch" :btnFilter="false" @reload="onReload" @filter="onFilter">
          <template v-slot:subtitle>
            <div class="subtitle-1 black--text">
              <b>{{ total }}</b> {{ jenis === 'luring' ? 'Kelas Luring' : 'Kelas BCMP' }} Tersistem
            </div>
          </template>
        </base-table-header>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-0">
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          @fetch="fetchData"
        >
          <template slot-scope="{ item }">
            <td>
              <v-list-item dense class="px-0">
                <v-list-item-content>
                  <v-row dense>
                    <v-col cols="12" md="4">
                      <v-list-item class="px-0">
                        <v-list-item-avatar color="primary">
                          <v-icon dark>mdi-teach</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content class="py-0 mt-3">
                          <div class="label--text">Nama Kelas</div>
                          <div class="body-1 black--text">
                            {{ $getDeepObj(item, 'nama') || '-' }}
                            <div class="caption grey--text">
                              {{ $getDeepObj(item, 'paud_diklat_luring.data.nama') }}
                            </div>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0 mt-3">
                          <div class="label--text">Tanggal Pelaksanaan</div>
                          <div class="pt-1">
                            {{
                              $durasi(
                                $getDeepObj(item, 'paud_diklat_luring.data.tgl_mulai') ||
                                  $getDeepObj(item, 'paud_diklat_bcmp.data.tgl_mulai'),
                                $getDeepObj(item, 'paud_diklat_luring.data.tgl_selesai') ||
                                  $getDeepObj(item, 'paud_diklat_bcmp.data.tgl_selesai')
                              )
                            }}
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-list-item>
                        <v-list-item-content class="py-0 mt-3">
                          <v-btn depressed small color="success" @click="toSertifikat(item)">
                            <v-icon left>mdi-file-edit</v-icon>
                            HASIL KELAS
                          </v-btn>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import list from '@mixins/list';
import BaseBreadcrumbs from '@components/base/BaseBreadcrumbs';
export default {
  mixins: [list],
  components: { BaseBreadcrumbs },
  data() {
    return {
      formulir: {},
      mapels: [],
      detail: {},
      catatans: {},
    };
  },
  computed: {
    ...mapState('master', {
      masters: (state) => Object.assign({}, state.masters),
    }),

    jenis() {
      return this.$getDeepObj(this.$route, 'meta.jenis') || 'luring';
    },

    breadcrumbs() {
      const types = {
        luring: [{ text: 'Diklat Luring Tersistem', to: `kelola-diklat-luring` }, { text: 'Sertifikat Diklat' }],
        bcmp: [{ text: 'Bimtek Bcmp', to: `kelola-diklat-bcmp` }, { text: 'Sertifikat Bimtek' }],
      };

      return types[this.jenis];
    },
  },
  mounted() {
    Object.assign(this.attr, { jenis: this.jenis });
  },
  methods: {
    ...mapActions('diklatSertifikat', ['fetch']),

    toSertifikat(item) {
      this.$router.push({ name: `${this.jenis}-sertifikat-peserta`, params: { kelas_id: item.id } });
    },
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #ffab91;
  height: 100%;
}
.sc-notif {
  background-color: #c8e6c9;
}
</style>
